/*
 * サブシステム名：マスタ管理
 * 機能名：基本情報設定
 */
import DdCustomButton from '@/components/DdCustomButton'
import DdTransparentButton from '@/components/DdTransparentButton'
import DdTorihikisakiKingakuDialog from '@/components/DdTorihikisakiKingakuDialog'
import VTour from '@/components/DdCoachMark.vue'
import CoachMark from './CoachMark/D2MSTT0280.js'

import flowMixin from '@/mixins/flowMixins'
import filter from '@/rahmen/utils/filters'
import message from '@/ddv2.library/messages'
import { mapGetters } from 'vuex'
import header from '@/ddv2.library/header'

const DdCodeTextBox = () => import('@/components/DdCodeTextBox')
const DdDataTable = () => import('@/components/DdDataTable')
const DdDateBox = () => import('@/components/DdDateBox')
const DdDropDown = () => import('@/components/DdDropDown')
const DdEditCommonBar = () => import('@/components/DdEditCommonBar')
const DdIconButtonWithTooltip = () => import('@/components/DdIconButtonWithTooltip')
const DdNumericBox = () => import('@/components/DdNumericBox')
const DdRadioButton = () => import('@/components/DdRadioButton')
const DdRadioGroup = () => import('@/components/DdRadioGroup')
const DdSectionTitle = () => import('@/components/DdSectionTitle')
const DdSubHeader = () => import('@/components/DdSubHeader')
const DdSubHeaderWithSwitch = () => import('@/components/DdSubHeaderWithSwitch')
const DdSubTitle = () => import('@/components/DdSubTitle')
const DdTextBox = () => import('@/components/DdTextBox')
const DdTimeBox = () => import('@/components/DdTimeBox')
const DdSwitch = () => import('@/components/DdSwitch')
const DdYearMonthBox = () => import('@/components/DdYearMonthBox.vue')

export default {
  name: 'MstKihonjohoEdit',
  mixins: [flowMixin],
  components: {
    VTour,
    DdCustomButton,
    DdTransparentButton,
    DdTorihikisakiKingakuDialog,
    DdCodeTextBox,
    DdDataTable,
    DdDateBox,
    DdDropDown,
    DdEditCommonBar,
    DdIconButtonWithTooltip,
    DdNumericBox,
    DdRadioButton,
    DdRadioGroup,
    DdSectionTitle,
    DdSubHeader,
    DdSubHeaderWithSwitch,
    DdSubTitle,
    DdSwitch,
    DdTextBox,
    DdTimeBox,
    DdYearMonthBox
  },
  data: () => ({
    rec: {},
    id: 1,

    // 操作ガイド用
    startCoachMark: false,
    steps: CoachMark.STEPS,

    modeKengen: 2, // 権限用
    modeOfEdit: 2, // 権限用
    recKingaku: {},
    recKingakuClone: {},
    meisai_dialog: false, // 明細ダイアログ
    ginkoKoza: [],
    desserts: [],
    chk: false, // validateチェック
    mstKingakuArray: [],
    mstKingaku: [],
    headersJishaginkokozaList: header.mstJishaGinkoKouzaHeaders,
    headers: [
      { value: 'actions', sortable: false, width: '60px' },
      { text: '金融機関コード', value: 'kinyuKikanCd' },
      { text: '金融機関名', value: 'kinyuKikanNm' },
      { text: '金融機関支店コード', value: 'kinyuKikanShitenCd' },
      { text: '金融機関支店名', value: 'kinyuKikanShitenNm' },
      { text: '口座種別', value: 'kozaSbt' },
      { text: '口座番号', value: 'kozaNo' },
      { text: '口座名義', value: 'kozaMeigiNm' }
    ],
    tab: [
      { href: '#tab1', value: '頻出項目' },
      { href: '#tab2', value: '課税項目' },
      { href: '#tab3', value: '非課税項目' },
      { href: '#tab4', value: '内税項目' }
    ],
    labelDegitaco1: 'デジタコ取込休憩時間算出方法',
    labelDegitaco2: 'デジタコ新規運行ID登録方法　',
    labelDegitaco3: 'デジタコ取込判定方法　　　　'
  }),
  computed: {
    ...mapGetters({
      viewTitle: 'system/viewTitle',
      jishaginkokozaList: 'DDMasters/mstJishaGinkoKoza',
      kihonjohoList: 'DDMasters/mstKihonjoho',
      kubunList: 'DDMasters/msysKubun',
      kingakuList: 'DDMasters/mstKingaku',
      helpUseFlg: 'users/helpUseFlg'
    }),
    // 自社銀行口座
    filteredJishaginkokozaList () {
      return this.jishaginkokozaList.map((elem) => {
        return elem
      }).sort((elem1, elem2) => {
        if (elem1.hyojiOrder - elem2.hyojiOrder !== 0) { return elem1.hyojiOrder - elem2.hyojiOrder }
        if (elem1.kinyuKikanCd > elem2.kinyuKikanCd) { return 1 }
        if (elem1.kinyuKikanCd < elem2.kinyuKikanCd) { return -1 }
        if (elem1.kinyuKikanShitenCd > elem2.kinyuKikanShitenCd) { return 1 }
        if (elem1.kinyuKikanShitenCd < elem2.kinyuKikanShitenCd) { return -1 }
        return 0
      })
    },
    // 当月基準
    filteredtogetsuKijunHandanKbnList () {
      return this.kubunList.filter(function (elem) {
        return elem.kbnShuruiCd === 'SFF064'
      }).map(function (elem) {
        elem.code = elem.code.trim()
        return elem
      })
    },
    // デジタコ取込休憩算出
    filtereddejitakoTorikomiKyukeisansyutsuKbnList () {
      return this.kubunList.filter(function (elem) {
        return elem.kbnShuruiCd === 'SFF098'
      }).map(function (elem) {
        elem.code = elem.code.trim()
        return elem
      })
    },
    // デジタコ新規運行ID登録方法
    filtereddejitakoShinkiunkoIdTorokuKbnList () {
      return this.kubunList.filter(function (elem) {
        return elem.kbnShuruiCd === 'SFF100'
      }).map(function (elem) {
        elem.code = elem.code.trim()
        return elem
      })
    },
    // デジタコ取込判定方法
    filtereddejitakoTorikomiHanteihohoKbnList () {
      return this.kubunList.filter(function (elem) {
        return elem.kbnShuruiCd === 'SFF099'
      }).map(function (elem) {
        elem.code = elem.code.trim()
        return elem
      })
    },
    // 金額集計区分
    filteredKingakuKubunList () {
      return this.kubunList.filter(function (elem) {
        return elem.kbnShuruiCd === 'KBN001'
      }).map(function (elem) {
        elem.value = elem.code.trim()
        elem.text = elem.codeNm.trim()
        return elem
      })
    },
    kazeiKbnList () {
      const list = this.kubunList.filter((elem) => elem.kbnShuruiCd === 'KBN001')
        .map((elem) => {
          elem.value = elem.code.trim()
          elem.text = elem.codeNm.trim()
          return elem
        })
      list.unshift({ value: '', text: '' })
      return list
    },
    filteredRows () {
      return this.rows.map((elem) => {
        elem.tekiyoStartYmdDisp = filter.dateFormatter(elem.tekiyoStartYmd)
        elem.tekiyoEndYmdDisp = filter.dateFormatter(elem.tekiyoEndYmd)
        return elem
      })
    },
    // 照会モード
    isShoukaiMode () {
      return this.modeOfEdit === 1
    },
    // ボタン表示非表示
    isButtonDisplay () {
      if (this.modeOfEdit === 2 && (this.modeKengen === 1 || this.modeKengen === 2)) {
        return true
      }
      return false
    }
  },
  created () {
  },
  mounted () {
    this.initialize()
  },
  methods: {
    // 初期値クローン
    getCloneTargetMethod: function () {
      return {
        rec: this.rec,
        ginkoKoza: this.ginkoKoza,
        recKingaku: this.recKingaku,
        recKingakuClone: this.recKingakuClone
      }
    },
    beforeRouteLeaveByMenu: function (next) {
      const opt = {
        nextCallback: next
      }
      this.preventTransition(opt)
    },
    fetchData: function () {
      return new Promise((resolve) => {
        this.HttpClient
          .get('/api/v1/Mstkihonjoho/GetAll')
          .then((data) => {
            this.rec = data.payload[0]

            // 区分
            this.rec.dejitakoShinkiunkoIdTorokuKbn = this.rec.dejitakoShinkiunkoIdTorokuKbn.trim()
            this.rec.dejitakoTorikomiKyukeisansyutsuKbn = this.rec.dejitakoTorikomiKyukeisansyutsuKbn.trim()
            this.rec.dejitakoTorikomiHanteihohoKbn = this.rec.dejitakoTorikomiHanteihohoKbn.trim()

            // 年月日フォーマット変換
            this.rec.kyuyoKishuYmdString = this.rec.kyuyoKishuYmd === null ? '' : filter.dateFormatter(this.rec.kyuyoKishuYmd)
            this.rec.kyuyoKimatsuYmdString = this.rec.kyuyoKimatsuYmd === null ? '' : filter.dateFormatter(this.rec.kyuyoKimatsuYmd)

            // 時刻フォーマット変換
            this.rec.shigyoJikanString = this.rec.shigyoJikan.slice(0, 5)
            this.rec.shugyoJikanString = this.rec.shugyoJikan.slice(0, 5)
            this.rec.shinyaJikanFromString = this.rec.shinyaJikanFrom.slice(0, 5)
            this.rec.shinyaJikanToString = this.rec.shinyaJikanTo.slice(0, 5)

            // 出庫みなし時間
            if (this.rec.shukkoMinashiJikan !== null) {
              this.rec.shukkoMinashiJikanString = this.rec.shukkoMinashiJikan.slice(0, 5)
            }
            if (this.rec.kikoMinashiJikan !== null) {
              this.rec.kikoMinashiJikanString = this.rec.kikoMinashiJikan.slice(0, 5)
            }

            // 日付・時刻項目削除
            delete this.rec.kyuyoKishuYmd
            delete this.rec.kyuyoKimatsuYmd
            delete this.rec.shigyoJikan
            delete this.rec.shugyoJikan
            delete this.rec.shinyaJikanFrom
            delete this.rec.shinyaJikanTo
            delete this.rec.shukkoMinashiJikan
            delete this.rec.kikoMinashiJikan

            // 銀行口座
            this.ginkoKoza = []
            this.setGinkoKoza(this.rec.jishaGinkoKozaId1)
            this.setGinkoKoza(this.rec.jishaGinkoKozaId2)
            this.setGinkoKoza(this.rec.jishaGinkoKozaId3)
            this.setGinkoKoza(this.rec.jishaGinkoKozaId4)
            this.setGinkoKoza(this.rec.jishaGinkoKozaId5)

            // 金額取得
            console.log('■金額取得用ID', this.rec.mstKingakuId)
            this.HttpClient
              .get(`/api/v1/mstkingaku/find?id=${this.rec.mstKingakuId}`)
              .then((dataKingaku) => {
                this.recKingaku = dataKingaku.payload
                this.recKingakuClone = dataKingaku.payload

                // 金額設定
                var mstKingakuArray = []
                mstKingakuArray.push(this.recKingaku)
                this.rec.mstKingaku = mstKingakuArray
                resolve()
                console.log('■this.ginkoKoza', this.ginkoKoza)
                console.log('■Initialixe this', this)
              })
          })
      })
    },

    writeBackGinkoKoza: function () {
      const self = this
      // 口座情報の書戻し(DataTable⇒rec)
      self.rec.jishaGinkoKozaId1 = null
      self.rec.jishaGinkoKozaId2 = null
      self.rec.jishaGinkoKozaId3 = null
      self.rec.jishaGinkoKozaId4 = null
      self.rec.jishaGinkoKozaId5 = null
      self.ginkoKoza.forEach(function (elem, index) {
        if (index === 0) { self.rec.jishaGinkoKozaId1 = elem.id }
        if (index === 1) { self.rec.jishaGinkoKozaId2 = elem.id }
        if (index === 2) { self.rec.jishaGinkoKozaId3 = elem.id }
        if (index === 3) { self.rec.jishaGinkoKozaId4 = elem.id }
        if (index === 4) { self.rec.jishaGinkoKozaId5 = elem.id }
      })
    },
    initialize () {
      const self = this
      const option = {
        loadMasters: ['mstkihonjoho', 'mstjishaginkokoza', 'msyskubun', 'mstkingaku'],
        initializeInputPromise: () => {
          return new Promise((resolve) => {
            self.rec = {
              suryoNumericLen: '6',
              suryoDecimalLen: '3',
              juryoNumericLen: '3',
              juryoDecimalLen: '3'
            }
            self.recKingaku = Object.assign({}, this.initializeKingaku)
            self.ginkoKoza = []
            self.meisai_dialog = false
            resolve()
          })
        },
        savedInputRestorePromise: () => {
          return new Promise((resolve) => {
            resolve()
          })
        },
        existsIdMethod: function () {
          // return self.id !== 0
          return true
        },
        requestApiPromise: self.fetchData,
        settingButtonStatePromise: (kengen) => {
          return new Promise((resolve) => {
            console.log('■settingButtonStatePromise', kengen)
            if (kengen.kengenKbn === '10') {
              // 読取モード
              this.modeKengen = 0
            } else if (kengen.kengenKbn === '20') {
              // 削除不可モード
              this.modeKengen = 1
            } else {
              // フルアクセス
              this.modeKengen = 2
            }
            // thisId == 0 then 新規モード
            if (this.id === 0) {
              this.modeOfEdit = 0 // 新規モード
            } else if (this.modeKengen === 0) {
              this.modeOfEdit = 1 // 照会モード
            } else {
              this.modeOfEdit = 2 // 更新モード
            }

            this.$nextTick(() => {
              document.getElementById('heavy-element').style.display = ''
            })

            resolve()
          })
        },
        settingItemMethod: (kengen) => {
          console.log('settingItemMethod', kengen)
        }
      }
      console.info('call initializeForRegister', this.initializeForRegister, option)
      this.initializeForRegister(option)
    },
    // キャンセルボタン
    onCancelButtonClick: function (e) {
      const self = this
      const opt = {
        restoreInputsPromise: function (data) {
          return new Promise(resolve => {
            self.rec = data().rec
            self.recKingaku = data().recKingaku
            self.recKingakuClone = data().recKingakuClone
            self.ginkoKoza = data().ginkoKoza
            self.rec.id = self.id
            resolve()
          })
        }
      }
      this.cancelInputs(opt)
    },
    // 明細閉じるボタン
    onDetailCloseButtonClick: function (e) {
      this.recKingaku = Object.assign({}, e)
      this.meisai_dialog = false
    },
    // 明細開くボタン
    onDetailOpenButtonClick: function () {
      this.meisai_dialog = true
    },
    replaceArrayElements: function (array, targetId, sourceId) {
      const cloneArray = [...array];
      [cloneArray[targetId], cloneArray[sourceId]] = [array[sourceId], array[targetId]]
      console.log('■並び替え', cloneArray)
      return cloneArray
    },
    setGinkoKoza: function (kozaId) {
      console.log('■setGinkoKoza', kozaId)
      if (kozaId !== null &&
          kozaId.trim !== '') {
        const kozaArr = this.jishaginkokozaList.filter(item => item.id === kozaId)
        // 口座種別名を取得
        const kbnArr = this.kubunList.filter(item => item.kbnShuruiCd === 'SFF070' &&
                                                     item.code.trim() === kozaArr[0].kozaSbt)
        console.log('kozaSbt', kbnArr[0].codeNm)
        kozaArr[0].kozaSbtNm = kbnArr[0].codeNm
        // 最終行に追加
        this.ginkoKoza.push(kozaArr[0])
      }
    },
    deleteKozaJoho: function (item) {
      console.log('deleteKozaJoho', item)
      const index = this.ginkoKoza.indexOf(item)
      this.ginkoKoza.splice(index, 1)
    },
    addKozaJoho: function () {
      console.log('addKozaJoho', this.rec.jishaGinkoKozaNm)
      if (this.rec.jishaGinkoKozaNm !== undefined &&
          this.rec.jishaGinkoKozaNm !== null &&
          this.rec.jishaGinkoKozaNm.trim !== '') {
        if (this.ginkoKoza.length >= 5) {
          // todo:アラート不要か？
          // alert('3行までです')
        } else {
          // // 重複チェック
          // const kozaArr = this.ginkoKoza.filter(item => item.id === this.rec.jishaGinkoKozaNm)
          // if (kozaArr.length !== 0) {
          //   // todo:アラート不要か？
          //   // alert('設定済の口座です')
          //   return
          // }
          this.setGinkoKoza(this.rec.jishaGinkoKozaNm)
          this.rec.jishaGinkoKozaNm = ''
        }
      }
    },
    upKozaJoho: function (item) {
      console.log('upKozaJoho', item)
      const index = this.ginkoKoza.indexOf(item)
      if (index > 0) {
        const cloneArray = this.replaceArrayElements(this.ginkoKoza, index, index - 1)
        this.ginkoKoza = cloneArray
      }
    },
    downKozaJoho: function (item) {
      console.log('downKozaJoho', item)
      const index = this.ginkoKoza.indexOf(item)
      if (index < this.ginkoKoza.length - 1) {
        const cloneArray = this.replaceArrayElements(this.ginkoKoza, index, index + 1)
        this.ginkoKoza = cloneArray
      }
    },
    // 保存ボタン
    onSaveButtonClick: function (e) {
      const self = this
      // 口座情報の書戻し
      this.writeBackGinkoKoza()
      const opt = {
        registerRequestPromise: self.registerPromise,
        registerResponsePromise: (data) => {
          return new Promise(resolve => {
            self.id = data.payload.id
            this.fetchData()
            resolve()
          })
        },
        getIdMethod: () => {
          return self.id
        },
        continuousInputInitializePromise: (id) => {
          console.log('continuousInputInitializePromise:', id)
          return new Promise(resolve => {
            this.id = id
            // this.transition(1, { id: id }, this.initialize)
            // this.transition(1, '', this.initialize)
            resolve()
          })
        },
        getTransitionBackParams: function () {
          console.log('getTransitionBackParams')
          return {
            actionId: 0,
            param: { id: self.rec.id }
          }
        },
        isUpdateModeMethod: function () {
          return self.id !== 0
        },
        isNoRefreshModeMethod: function () {
          return true
        }
      }
      console.log('■更新処理開始 - option ', opt)
      this.register(opt)
    },
    registerPromise: function () {
      // 金額設定
      var mstKingakuArray = []
      mstKingakuArray.push(this.recKingaku)
      this.rec.mstKingaku = mstKingakuArray
      // 更新
      const f = this.HttpClient.put(`/api/v1/MstKihonjoho/updateMulti?id=${this.rec.id}`, this.rec)
      return f
    },
    // 振込先の追加ボタン
    onAddJishaginkokozaClick: function (e) {
      // 口座情報追加
      this.addKozaJoho(e)
    },
    registerValidate: function () {
      this.chk = true
      // 決算月 1~12
      if (this.rec.kessanMonth > 0 && this.rec.kessanMonth <= 12) {
      } else {
        // this.$refs.kessanMonth[this.Ctrls.SET_INVALID_METHOD](msg) COMV0114
        this.$refs.kessanMonth[this.Ctrls.SET_INVALID_METHOD](message.get('COMV0114', ['決算月', '1', '12']))
        this.chk = false
      }
      // 自社締日 1~31 99
      if (this.rec.jishaShimeDay >= 1 && this.rec.jishaShimeDay <= 31) {
      } else {
        if (Number(this.rec.jishaShimeDay) === 99) {
        } else {
          // this.$refs.kessanMonth[this.Ctrls.SET_INVALID_METHOD](msg) COMV0015
          this.$refs.jishaShimeDay[this.Ctrls.SET_INVALID_METHOD](message.get('COMV0015', ['自社締日']))
          this.chk = false
        }
      }

      // 給与締日 1~31 99
      if ((this.rec.kyuyoShimeDay >= 1 && this.rec.kyuyoShimeDay <= 31) || !this.rec.kyuyoShimeDay) {
      } else {
        if (Number(this.rec.kyuyoShimeDay) === 99) {
        } else {
          this.$refs.kyuyoShimeDay[this.Ctrls.SET_INVALID_METHOD](message.get('COMV0015', ['給与締日']))
          this.chk = false
        }
      }

      return this.chk
    }
  }
}
